module.exports = __webpack_public_path__ + "img/building95-5.dacf1087.jpg";